module.exports = __webpack_public_path__ + "static/media/img-moduleB2.7f1b1dda.png";